<template>
  <div class="recap-sdd d-flex flex-column justify-center">
    <span class="resultTitle mx-auto">{{$t('mandate_signed')}}</span>

    <div class="result-table mt-4">
      <div v-for="item in values" :key="item.label" class="d-flex divider">
        <div class="formLabel">{{$t(item.label)}}</div>
        <div class="formValue">{{item.value}}</div>
      </div>
    </div>
    <div class="d-flex justify-left">
      <div v-if="canDownload" class="pdf-maker-container clickable mt-6" @click="download">
        <div class="d-flex align-center justify-left">
          <img 
            src="@/assets/document-pdf-outline.svg"
            class="pressable"/>
          <span class="download-label ml-2">{{$t('download_your_mandate')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils'
  import formatMixin from '@/mixins/formatMixin'
  import downLoadHelper from '@/mixins/downloadBase64'

  export default {
    name: 'RecapSDD',
    mixins: [downLoadHelper, formatMixin],
    props: {
      params: {
        type: Object,
        default: () => ({})
      },
    },
    data() {
      return {
        values: [
          { label: 'amount', value: ((this.params && this.params.mkpData && this.params.mkpData.amount) ? this.formatAmount(utils.round(this.params.mkpData.amount, 2), this.params.mkpData.currencyCode, 2) : this.params.mkpData.currencyCode) },
          { label: 'rum', value: this.params.transactionData.mndtRef },
          { label: 'iban_to_use', value: this.params.startPaymentData.iban },
          { label: 'date', value: this.$t('dateAndTime').replace('{0}', this.timevalueToNumericDate(new Date())).replace('{1}', this.timevalueToTime(new Date())) }
        ],
        fileContent: this.params.transactionData.signedFileContent
      }
    },
  }
</script>